// styles.js - All styling constants
export const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
        padding: '16px',
        fontFamily: 'system-ui, -apple-system, sans-serif'
    },
    maxWidth: {
        maxWidth: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '0 20px'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px'
    },
    title: {
        color: 'white',
        fontSize: '2.5rem',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        margin: 0
    },
    subtitle: {
        color: '#d1d5db',
        marginTop: '8px',
        fontSize: '1rem'
    },
    headerControls: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        flexWrap: 'wrap'
    },
    statusBadge: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderRadius: '8px',
        fontSize: '0.875rem',
        fontWeight: '500'
    },
    statusConnected: {
        backgroundColor: 'rgba(5, 150, 105, 0.3)',
        color: '#10b981'
    },
    statusDisconnected: {
        backgroundColor: 'rgba(239, 68, 68, 0.3)',
        color: '#ef4444'
    },
    statusChecking: {
        backgroundColor: 'rgba(245, 158, 11, 0.3)',
        color: '#f59e0b'
    },
    statusDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%'
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '0.875rem',
        fontWeight: '500',
        transition: 'all 0.2s ease'
    },
    buttonPrimary: {
        backgroundColor: '#f59e0b',
        color: '#000'
    },
    buttonSecondary: {
        backgroundColor: '#dc2626',
        color: 'white'
    },
    buttonDisabled: {
        backgroundColor: '#6b21a8',
        color: '#e5e7eb',
        cursor: 'not-allowed'
    },
    errorAlert: {
        backgroundColor: 'rgba(217, 119, 6, 0.2)',
        border: '1px solid rgba(217, 119, 6, 0.5)',
        color: '#fbbf24',
        padding: '12px 16px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '12px'
    },
    statsCard: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 193, 7, 0.2)',
        borderRadius: '12px',
        padding: '20px'
    },
    statsCardContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    statsLabel: {
        color: '#9ca3af',
        fontSize: '0.75rem',
        margin: '0 0 2px 0'
    },
    statsValue: {
        color: 'white',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        margin: 0
    },
    filtersContainer: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 193, 7, 0.2)',
        borderRadius: '12px',
        padding: '20px'
    },
    filtersGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '12px'
    },
    searchContainer: {
        position: 'relative'
    },
    searchInput: {
        width: '100%',
        paddingLeft: '40px',
        paddingRight: '16px',
        paddingTop: '8px',
        paddingBottom: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        color: 'white',
        fontSize: '0.875rem',
        outline: 'none',
        transition: 'border-color 0.2s ease'
    },
    searchIcon: {
        position: 'absolute',
        left: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#9ca3af'
    },
    select: {
        padding: '8px 16px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        color: 'white',
        fontSize: '0.875rem',
        outline: 'none',
        cursor: 'pointer',
        width: '100%'
    },
    tableContainer: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 193, 7, 0.2)',
        borderRadius: '12px',
        overflow: 'hidden'
    },
    tableHeader: {
        padding: '16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    tableTitle: {
        color: 'white',
        fontSize: '1.25rem',
        fontWeight: '600',
        margin: '0 0 12px 0'
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        color: '#d1d5db'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    tableHeaderCell: {
        textAlign: 'left',
        padding: '16px 20px',
        color: '#fbbf24',
        fontWeight: '600',
        borderBottom: '2px solid rgba(255, 193, 7, 0.3)',
        fontSize: '0.875rem',
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
    },
    tableRow: {
        borderBottom: '1px solid rgba(255, 193, 7, 0.1)',
        transition: 'background-color 0.2s ease'
    },
    tableCell: {
        padding: '16px 20px',
        fontSize: '0.875rem',
        lineHeight: '1.5'
    },
    tableCellWhite: {
        color: 'white'
    },
    tableCellGray: {
        color: '#d1d5db'
    },
    badge: {
        padding: '4px 8px',
        borderRadius: '6px',
        fontSize: '0.75rem',
        fontWeight: '500'
    },
    badgeBlue: {
        backgroundColor: 'rgba(59, 130, 246, 0.2)',
        color: '#93c5fd'
    },
    badgeOrange: {
        backgroundColor: 'rgba(255, 165, 0, 0.3)',
        color: '#ffb347',
        border: '1px solid rgba(255, 165, 0, 0.4)'
    },
    badgeRed: {
        backgroundColor: 'rgba(239, 68, 68, 0.3)',
        color: '#fca5a5',
        border: '1px solid rgba(239, 68, 68, 0.4)'
    },
    badgePurple: {
        backgroundColor: 'rgba(147, 51, 234, 0.2)',
        color: '#c4b5fd'
    },
    statusRed: {
        color: '#fca5a5'
    },
    statusGreen: {
        color: '#86efac'
    },
    statusBlue: {
        color: '#93c5fd'
    },
    statusYellow: {
        color: '#fde047'
    },
    emptyState: {
        textAlign: 'center',
        padding: '32px',
        color: '#9ca3af'
    },
    emptyIcon: {
        margin: '0 auto 16px auto',
        opacity: '0.5'
    }
};